import _regeneratorRuntime from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _typeof from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import router from '@/router';
// 引入vuex的
import store from '@/store';
import NProgress from 'nprogress'; // 引入一份进度条插件
import 'nprogress/nprogress.css'; // 引入进度条样式
import { getMenuList } from './api/systemAdmin';
import { isEmpty } from 'xe-utils';
// 定义白名单  所有不受权限控制的页面
var whiteList = ['/login', '/404'];
function syncTitle(_x) {
  return _syncTitle.apply(this, arguments);
} // 路由前置守卫
function _syncTitle() {
  _syncTitle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(routes) {
    var MenuRes, scanGetTitles, titleMap, scanSetTitles;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          scanSetTitles = function _scanSetTitles(arr) {
            var titleMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
            arr.forEach(function (it) {
              if (titleMap.has(it.name)) {
                it.meta.title = titleMap.get(it.name);
              }
              if (!isEmpty(it.children)) scanGetTitles(it.children, titleMap);
            });
          };
          scanGetTitles = function _scanGetTitles(arr) {
            var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
            arr.forEach(function (it) {
              map.set(it.permission, it.menuTitle);
              if (!isEmpty(it.menuVOList)) scanGetTitles(it.menuVOList, map);
            });
            return map;
          };
          _context2.next = 4;
          return getMenuList();
        case 4:
          MenuRes = _context2.sent;
          titleMap = scanGetTitles(MenuRes.data);
          /** 扫描设置 titles */
          scanSetTitles(routes, titleMap);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _syncTitle.apply(this, arguments);
}
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var _yield$store$dispatch, data, routes1;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // 打开进度条
          NProgress.start();
          // 如果有token
          if (!store.getters.token) {
            _context.next = 24;
            break;
          }
          if (!(to.path == '/login')) {
            _context.next = 6;
            break;
          }
          // 有token去登录页那么跳转到主页
          next('/');
          _context.next = 22;
          break;
        case 6:
          if (store.getters.staffCode) {
            _context.next = 21;
            break;
          }
          _context.next = 9;
          return store.dispatch('user/getUserInfo');
        case 9:
          _yield$store$dispatch = _context.sent;
          data = _yield$store$dispatch.data;
          _context.next = 13;
          return store.dispatch('permission/filterRoutes', data.menusRoles.menus);
        case 13:
          routes1 = _context.sent;
          _context.next = 16;
          return syncTitle(routes1);
        case 16:
          router.addRoutes([].concat(_toConsumableArray(routes1), [{
            path: '*',
            redirect: '/404',
            hidden: true
          }]));
          //next(to.path)相当于添加动态路由路还没铺好,出去再重新进来路就铺好了  
          if (_typeof(data) === 'object') {
            next(to.path);
          }
          next("/login");
          _context.next = 22;
          break;
        case 21:
          // 有token不是去登录页就放行
          next();
        case 22:
          _context.next = 25;
          break;
        case 24:
          // 没有token判断是不是去往白名单页面
          if (whiteList.indexOf(to.path) > -1) {
            next();
          } else {
            // 没有在白名单里面跳转到登录页
            next('/login');
          }
        case 25:
          // 关闭进度条
          NProgress.done();
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}());
// 路由后置守卫
router.afterEach(function () {
  // 关闭进度条
  NProgress.done();
});